import React from 'react';

interface Option {
  value: string;
  label: string;
}

interface SelectFieldProps {
  label: string;
  name: string;
  required?: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: Option[];
  disabled?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  name,
  required = false,
  value,
  onChange,
  options,
  disabled = false
}) => {
  return (
    <div>
      <label htmlFor={name} className="block text-sm font-medium text-blue-100">
        {label} {required && '*'}
      </label>
      <select
        id={name}
        name={name}
        required={required}
        disabled={disabled}
        className="mt-1 block w-full rounded-xl bg-white/10 border-white/10 text-blue-100 focus:border-blue-400 focus:ring-blue-400 disabled:bg-white/5 disabled:text-blue-200 transition-colors duration-200"
        value={value}
        onChange={onChange}
      >
        <option value="">{`Select ${label}`}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectField;